import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const REPORT_API_URL = process.env.REACT_APP_API_URL + "/api/reports/";

const getWorkstationIpAnalysis = (months = null, sameDay = true, timezone = 'UTC') => {
  const params = {};
  if (months !== null) params.months = months;
  if (sameDay !== null) params.sameDay = sameDay;
  if (timezone) params.timezone = timezone;

  return axios.get(
    `${REPORT_API_URL}workstation-ip-analysis`,
    {
      headers: authHeader(),
      params
    }
  );
};

const getWorkstationIpConflictDetails = (clientId, conflictDate, months, timezone) => {
    return axios.get(`${REPORT_API_URL}workstation-ip-conflict-details`, {
        headers: authHeader(),
        params: { clientId, conflictDate, months, timezone }
    });
};

const getWorkstationAuditDetails = (clientId, workstation, conflictDate, timezone) => {
    return axios.get(`${REPORT_API_URL}workstation-audit-details`, {
        headers: authHeader(),
        params: { clientId, workstation, conflictDate, timezone }
    });
};

const getSyncBandwidth = (startDate, endDate, timezone, search = null) => {
  const params = { startDate, endDate, timezone };
  if (search && search.trim() !== "") {
    params.search = search.trim();
  }
  return axios.get(
    `${REPORT_API_URL}sync-bandwidth`,
    {
      headers: authHeader(),
      params
    }
  );
};

const getDataUsage = (startDate, endDate, timezone = "UTC", search = null) => {
  const params = { startDate, endDate, timezone };
  if (search && search.trim() !== "") {
    params.search = search.trim();
  }
  return axios.get(
    `${REPORT_API_URL}data-usage`,
    {
      headers: authHeader(),
      params
    }
  );
};

const getWorkstationVersions = (search = null) => {
  const params = {};
  if (search && search.trim() !== "") {
    params.search = search.trim();
  }
  return axios.get(
    `${REPORT_API_URL}workstation-versions`,
    {
      headers: authHeader(),
      params
    }
  );
};

const getStorageSize = (clientId) => {
  return axios.get(
    `${REPORT_API_URL}storage-size`,
    {
      headers: authHeader(),
      params: {
        clientId
      }
    }
  );
};

const getClientShopWorkstations = (clientId = null, page = 0, size = 50) => {
  const params = { page, size };
  if (clientId) params.clientId = clientId;

  return axios.get(
    `${REPORT_API_URL}client-shop-workstations`,
    {
      headers: authHeader(),
      params
    }
  );
};

const blockWorkstation = (workstationId, shopName = null) => {
  const params = { workstationId };
  if (shopName) params.shopName = shopName;

  return axios.post(
    `${REPORT_API_URL}block-workstation`,
    null,
    {
      headers: authHeader(),
      params
    }
  );
};

const unblockWorkstation = (workstationId) => {
  return axios.post(
    `${REPORT_API_URL}unblock-workstation`,
    null,
    {
      headers: authHeader(),
      params: { workstationId }
    }
  );
};



const whitelistShop = (shopName, clientIds) => {
  return axios.post(`${REPORT_API_URL}whitelist-shop`, null, {
    headers: authHeader(),
    params: { shopName, clientIds: clientIds.join(',') }
  });
};

const blacklistShop = (shopName) => {
  return axios.post(`${REPORT_API_URL}blacklist-shop`, null, {
    headers: authHeader(),
    params: { shopName }
  });
};

const deleteShopReportsByShopName = (shopName) => {
  return axios.post(`${REPORT_API_URL}delete-shop-reports`, null, {
    headers: authHeader(),
    params: { shopName }
  });
};

const getWhiteListShops = (searchTerm = "", page = 0, size = 50) => {
  return axios.get(`${REPORT_API_URL}get-white-list-shops`, {
    headers: authHeader(),
    params: { searchTerm, page, size }
  });
};

const removeFromWhiteList = (shopName) => {
  return axios.post(`${REPORT_API_URL}remove-from-white-list`, null, {
    headers: authHeader(),
    params: { shopName }
  });
};

const moveFromWhiteListToBlackList = (shopName) => {
  return axios.post(`${REPORT_API_URL}move-to-black-list`, null, {
    headers: authHeader(),
    params: { shopName }
  });
};

const getBlackListShops = (searchTerm = "", page = 0, size = 50) => {
  return axios.get(`${REPORT_API_URL}get-black-list-shops`, {
    headers: authHeader(),
    params: { searchTerm, page, size }
  });
};

const removeFromBlackList = (shopName) => {
  return axios.post(`${REPORT_API_URL}remove-from-black-list`, null, {
    headers: authHeader(),
    params: { shopName }
  });
};

const getBlockedWorkstations = (page = 0, size = 50) => {
  return axios.get(`${REPORT_API_URL}get-blocked-workstations`, {
    headers: authHeader(),
    params: { page, size }
  });
};

const getClientWbList = (clientId) => {
  return axios.get(`${REPORT_API_URL}client-wb-list`, {
    headers: authHeader(),
    params: { clientId }
  });
};

const getTrespassRequests = (requestType, status = null, search = "", page = 0, size = 50) => {
  const params = { page, size };
  if (requestType) params.requestType = requestType;
  if (status) params.status = status;
  if (search && search.trim() !== "") params.search = search.trim();

  return axios.get(`${REPORT_API_URL}trespass-requests`, {
    headers: authHeader(),
    params
  });
};

const updateTrespassRequestStatus = (requestId, status) => {
  return axios.post(`${REPORT_API_URL}trespass-requests/update-status`, null, {
    headers: authHeader(),
    params: { requestId, status }
  });
};

const deleteTrespassRequest = (requestId) => {
  return axios.post(`${REPORT_API_URL}trespass-requests/delete`, null, {
    headers: authHeader(),
    params: { requestId }
  });
};

const reportService = {
  getWorkstationIpAnalysis,
  getWorkstationIpConflictDetails,
  getWorkstationAuditDetails,
  getSyncBandwidth,
  getDataUsage,
  getWorkstationVersions,
  getStorageSize,
  getClientShopWorkstations,
  blockWorkstation,
  unblockWorkstation,

  whitelistShop,
  blacklistShop,
  deleteShopReportsByShopName,
  getWhiteListShops,
  removeFromWhiteList,
  moveFromWhiteListToBlackList,
  getBlackListShops,
  removeFromBlackList,
  getBlockedWorkstations,
  getClientWbList,
  getTrespassRequests,
  updateTrespassRequestStatus,
  deleteTrespassRequest
};

export default reportService;
